module.exports = __webpack_public_path__ + "img/kilauea-volcano.8d481b2e.jpg";